import api from '../client';

/**
 * Service pour la gestion des relances programmées (Smart Follow-ups).
 * Base: /api/v1/reminders
 */
const reminderService = {
  /**
   * Récupérer les relances.
   * @param {Object} params - Filtres (status, conversationId, from, to)
   * @returns {Promise} { success, data: Reminder[] } (déjà trié par triggerAt croissant)
   */
  getReminders: async (params = {}) => {
    try {
      const response = await api.get('/reminders', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Créer une relance manuelle.
   * @param {Object} data - { conversationId, triggerAt (ISO), reason, contextSummary?, clientName? }
   * @returns {Promise} Reminder créé
   */
  createReminder: async (data) => {
    try {
      const response = await api.post('/reminders', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Reprogrammer / modifier une relance.
   * @param {string} id
   * @param {Object} data - { triggerAt?, reason?, contextSummary? }
   * @returns {Promise} Reminder mis à jour
   */
  updateReminder: async (id, data) => {
    try {
      const response = await api.put(`/reminders/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Annuler une relance (status → cancelled).
   * @param {string} id
   * @returns {Promise} Reminder mis à jour
   */
  cancelReminder: async (id) => {
    try {
      const response = await api.patch(`/reminders/${id}/cancel`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Supprimer définitivement une relance.
   * @param {string} id
   * @returns {Promise} Confirmation
   */
  deleteReminder: async (id) => {
    try {
      const response = await api.delete(`/reminders/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default reminderService;
